import { Home, Building2, Megaphone } from 'lucide-react';

const verticals = [
  {
    icon: Home,
    name: 'Homeowner Associations',
    tag: 'HOA',
    desc: 'Property management, violation tracking, architectural review boards, assessments, common area maintenance, and homeowner communication portals.',
    features: [
      'Property & unit tracking',
      'Violation management',
      'Architectural review workflows',
      'Assessment billing & collections',
      'Common area maintenance logs',
      'Homeowner self-service portal',
    ],
  },
  {
    icon: Building2,
    name: 'Chambers of Commerce',
    tag: 'Chamber',
    desc: 'Business directory, membership tiers, ribbon cuttings, networking events, economic development tracking, and ambassador programs.',
    features: [
      'Business member directory',
      'Tiered membership levels',
      'Ribbon cutting & event calendar',
      'Ambassador program management',
      'Sponsorship tracking',
      'Economic development reports',
    ],
  },
  {
    icon: Megaphone,
    name: 'Advocacy Organizations',
    tag: 'Advocacy',
    desc: 'Legislation tracking, grassroots campaigns, action alerts, PAC management, elected official databases, and constituent engagement scoring.',
    features: [
      'Legislation bill tracking',
      'Action alert campaigns',
      'Grassroots mobilization tools',
      'Elected official database',
      'Engagement scoring',
      'PAC & fundraising management',
    ],
  },
];

export function VerticalsSection() {
  return (
    <section id="verticals" className="relative py-28 sm:py-32">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 60% 40% at 50% 50%, rgba(20,184,166,0.04) 0%, transparent 70%)',
        }}
      />

      <div className="relative mx-auto max-w-6xl px-6">
        <div className="mb-16 text-center reveal">
          <span className="mb-4 inline-block rounded-full border border-ams-700/40 bg-ams-950/40 px-3 py-1 text-xs font-medium text-ams-400">
            Built for Your Industry
          </span>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Purpose-Built Verticals
          </h2>
          <p className="mx-auto max-w-2xl text-zinc-400">
            Not a generic CRM with "association mode." Each vertical has dedicated features designed by people who understand your industry.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {verticals.map((v) => (
            <div
              key={v.name}
              className="vertical-card reveal rounded-2xl border border-ams-800/30 bg-ams-950/20 p-8 backdrop-blur"
            >
              <div className="mb-4 flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-ams-500/10">
                  <v.icon className="h-6 w-6 text-ams-400" />
                </div>
                <div>
                  <span className="rounded-full bg-ams-500/10 px-2 py-0.5 text-[10px] font-semibold text-ams-400">
                    {v.tag}
                  </span>
                </div>
              </div>

              <h3 className="mb-2 text-lg font-bold">{v.name}</h3>
              <p className="mb-6 text-sm leading-relaxed text-zinc-400">{v.desc}</p>

              <ul className="space-y-2.5">
                {v.features.map((feat) => (
                  <li key={feat} className="flex items-start gap-2 text-sm text-zinc-300">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-ams-500" />
                    {feat}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
